import { Text } from "../../../../components/common/typography";
import { UploadedDocumentItem } from "./uploaded-document-item";
import type { UserDtoDocumentsInner } from "../../../../api/api";

interface UploadedDocumentsSectionProps {
  documents: UserDtoDocumentsInner[];
}

export function UploadedDocumentsSection({
  documents,
}: UploadedDocumentsSectionProps) {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div>
      <Text variant="bodyLg" tone="dark" className="mb-3">
        Uploaded Documents
      </Text>
      <div className="space-y-2">
        {documents.map((doc, index) => (
          <UploadedDocumentItem key={index} document={doc} />
        ))}
      </div>
    </div>
  );
}
